document.addEventListener("DOMContentLoaded", function(){
  const currentPath = window.location.pathname
  const $sidebarTarget =  $(`.sidebar-link[href='${currentPath}']`)

  if (!$sidebarTarget.length){
    return;
  }

  $sidebarTarget.addClass("text-white")
  $sidebarTarget.addClass("fw-bold")
  if ($sidebarTarget.children("i").length){
    $sidebarTarget.children("i").addClass("text-white")
  }

  const $sidebarTargetParent = $sidebarTarget.closest("ul").closest(".sidebar-item").children(".sidebar-link")
  if ($sidebarTargetParent.length) {
    $sidebarTargetParent.addClass("text-white")
    $sidebarTargetParent.addClass("fw-bold")
    
    $sidebarTargetParent.removeClass("collapsed")
    $sidebarTargetParent.attr("aria-expanded", "true")
    $sidebarTargetParent.closest("li").children("ul").addClass("show")

    if ($sidebarTargetParent.children("i").length){
      $sidebarTargetParent.children("i").addClass("text-white")
    }
  }
})

$(document).on("click", ".sidebar-link", function(){
  $('.sidebar-link').removeClass("text-white")
  $('.sidebar-link').find("svg").removeClass("text-white")
  $('.sidebar-link').removeClass("fw-bold")

  $(this).addClass("text-white")
  $(this).addClass("fw-bold")

  if ($(this).children("svg").length){
    $(this).children("svg").addClass("text-white")
  }

  const parent = $(this).closest("ul").closest(".sidebar-item").children(".sidebar-link")
  if (parent.length) {
    parent.addClass("text-white")
    parent.addClass("fw-bold")
    if (parent.children("svg").length){
      parent.children("svg").addClass("text-white")
    }
  }
})